export default __webpack_public_path__ + "static/media/canonesOpen.d4912b0b.jpg";